export default "__VITE_ASSET__cb1a7287__"